import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import EmptyBox from "../Box/EmptyBox";
import ErrorBox from "../Box/ErrorBox";
import { Icon, IconButton, Skeleton, Tooltip } from "@mui/material";
// import { Box } from '@mui/system';
// import Lottie from 'react-lottie-player'
// import AnimiJSON from './rippleAnimiJson.json';
import { useNewRows } from "../../features";

interface ActionType {
  tootlTip : string;
  onActionClick : (row: any) => void;
  icon : string
}

interface ColumnType {
  id : number | string;
  label : string;
  minWidth : number;
  align? : "right" | "left" | "center";
  format?: (value : any) => string;
  actions?: ActionType[]
}

interface RowData {
  _id: string | number;
  [key: string] : any
}


interface TableProps {
  isError : boolean;
  isLoading: boolean;
  errorMsg: string
  onError : () => void;
  rowsPerPage : number;
  page : number;
  totalRow : number;
  columnsConfig: ColumnType[];
  rowData : RowData[];
  handleChangePage?: (page: number) => void;
  handleChangeRowsPerPage?: (rowsPerPage: number, page: number) => void;
  handleOnRowClick?: (row: any) => void;
  noPagination?: boolean;
}

const TableSkeleton = () => {
  return (
    <>
      <Skeleton height={60} />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
      <Skeleton />
    </>
  );
};

export default function StickyHeadTable(props : TableProps) {
  const _handleChangePage = (event : React.MouseEvent | null, newPage : number) => {
    if(props.handleChangePage) {
      props.handleChangePage(newPage);
    }
  };
  const _handleChangeRowsPerPage = (event : React.ChangeEvent<HTMLInputElement>) => {
    if(props.handleChangeRowsPerPage) {
      props.handleChangeRowsPerPage(+event.target.value, 0);
    }
  };
  const { newRows, removeNewRow } = useNewRows();

  function compare(id : RowData['_id']) {
    if(newRows?.length > 0){
      const res = newRows.filter((i : RowData['_id']) => i == id).length;
      return res > 0 ? true : false;
    }
  }
  function handleOnRowClick(e : React.MouseEvent, row : {_id : RowData["_id"]}) {
    e.stopPropagation();
    removeNewRow(row._id);
    if(props.handleOnRowClick) {
      props.handleOnRowClick(row);
    }
  }
  return (
    <Paper elevation={0} sx={{ width: "100%", overflow: "hidden" }}>
      {/* <NewRowIndicator /> */}
      {props.isError ? (
        <ErrorBox onError={props.onError} errorMsg={props.errorMsg} />
      ) : props.isLoading ? (
        <TableSkeleton />
      ) : props?.rowData?.length > 0 ? (
        <>
          <Table stickyHeader aria-label="data table">
            <TableHead>
              <TableRow>
                {props.columnsConfig.map((column, idx) => (
                  <TableCell
                    key={"table_header_cell_" + idx + "_" + column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody sx={{ position: "relative" }}>
              {props.rowData.map((row, index) => {
                return (
                  <React.Fragment key={"table_body_row_" + index}>
                    {compare(row._id) && (
                      <img
                        style={{
                          position: "absolute",
                          marginTop: 0,
                          marginRight: 0,
                          right: 0,
                        }}
                        width={45}
                        src={"/images/new-tag.png"}
                      />
                    )}
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={"tableRow_" + index}
                      onClick={(e : React.MouseEvent) => handleOnRowClick(e, row)}
                      sx={{ cursor: "pointer" }}
                    >
                      {props.columnsConfig.map((column , idx : number) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={"tableCell_" + index + "_" + idx}
                            align={column.align}
                          >
                            {column.id !== "actions" &&
                            column.format &&
                            typeof value === "number"
                              ? column.format(value)
                              : value}
                            {column.id === "actions" &&
                              column.actions &&
                              column.actions.length > 0 &&
                              column.actions.map((action, index) => (
                                <Tooltip
                                  key={"tooltip_" + index.toString()}
                                  title={action.tootlTip}
                                >
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      action.onActionClick(row);
                                    }}
                                  >
                                    <Icon>{action.icon}</Icon>
                                  </IconButton>
                                </Tooltip>
                              ))}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
          {!props.noPagination ? (
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={props.totalRow}
              rowsPerPage={props.rowsPerPage}
              page={props.page}
              onPageChange={_handleChangePage}
              onRowsPerPageChange={_handleChangeRowsPerPage}
            />
          ) : null}
        </>
      ) : (
        <EmptyBox />
      )}
    </Paper>
  );
}